<script setup>
import { computed } from 'vue';

const props = defineProps({
  count: { type: [Number, String], default: 0 },
  compact: { type: Boolean, default: false },
});

const normalizedCount = computed(() => {
  const count = Number(props.count);
  return Number.isFinite(count) && count > 0 ? count : 0;
});
</script>

<template>
  <span
    v-if="normalizedCount > 0"
    data-test-id="sidebar-unread-badge"
    class="inline-flex w-fit shrink-0 items-center justify-center whitespace-nowrap rounded-full bg-n-teal-3 font-medium leading-none text-n-teal-11 tabular-nums"
    :class="
      compact ? 'h-4 min-w-5 px-1 text-xxs' : 'h-5 min-w-6 px-1.5 text-xs'
    "
  >
    {{ normalizedCount }}
  </span>
  <span v-else class="hidden" />
</template>
